import { getThemeHomePreview } from '@runtime/core/theme/posterThemes'
import fallback from './assets/activity-fallback.svg'

export function homeActivityImages(themeId: string, activity: 'strategy' | 'puzzle') {
  const preview = getThemeHomePreview(themeId, activity)
  // Runtime-generated SVG placeholders contain embedded labels; Home uses a text-free fallback.
  return preview.startsWith('data:image/svg+xml') ? [fallback] : [preview, fallback]
}
